module.exports = __webpack_public_path__ + "static/media/manual_043.4b3837bf.jpg";